import React, { Component } from 'react';
import { Container, Tabs, Tab, Alert } from 'react-bootstrap';
import { GoOrganization, GoGear } from "react-icons/go";
import ReactGA from 'react-ga';
import Profile from "components/profile/profile";
import Organizations from "components/profile/organizations";
import Settings from "./settings/settings";

export default class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      orgs: null,
      notFound: false,
    };

    this.profileInterface = {
      loadProfile: this.loadProfile
    };
  }

  componentDidMount() {
    ReactGA.pageview('/profile/user');

    this.loadData();
  }

  loadData() {
    // Query user profile
    this.loadProfile();

    // Query the list of user's organizations
    const userId = this.props.match.params.userId;
    this.props.app.api.users_id_orgs_get(userId)
      .then(response => {
        this.setState({ orgs: response.data.organizations });
      }, error => {});
  }

  loadProfile = () => {
    const userId = this.props.match.params.userId;
    this.props.app.api.usersIdGetNoCache(userId)
      .then(response => {
        this.setState({ user: response.data.user });
      }, error => {
        this.setState({ notFound: true });
      });
  }

  handleTabSelect(tabSection) {
    const userId = this.props.match.params.userId;

    // Redirect to corresponding page
    var pagePath = `\/p\/${userId}`;
    if ( "organizations" != tabSection ) {
      pagePath += `\/${tabSection}`;
    }
    this.props.history.push(pagePath);
  }

  render() {
    if ( this.state.notFound ) {
      return (
        <>
          <Container className="blob-header-row header-message-row">
            <Alert variant="warning">Requested user has not been found.</Alert>
          </Container>
        </>
      );
    }

    if ( !this.state.user ) {
      return (
        <>
          <Container className="blob-header-row header-message-row">
            <Alert variant="primary">Loading user profile...</Alert>
          </Container>
        </>
      );
    }

    const section = this.props.match.params.section || "organizations";

    return (
      <>
        <Profile
          app={this.props.app}
          user={this.state.user}
        />
        <br/>

        <Container className="blob-header-row main-tabs">
          <Tabs defaultActiveKey="organizations" activeKey={section} onSelect={(key) => this.handleTabSelect(key)}>
            <Tab eventKey="organizations" title={<><GoOrganization/> Organizations</>}></Tab>
            {this.props.app.api.isSelfUser(this.state.user) &&
              <Tab eventKey="settings" title={<><GoGear/> Settings</>}></Tab>
            }
          </Tabs>
        </Container>

        <div className={"organizations" === section ? "" : "hidden"}>
          <Organizations
            app={this.props.app}
            user={this.state.user}
            orgs={this.state.orgs}
          />
        </div>

        {this.props.app.api.isSelfUser(this.state.user) &&
          <div className={"settings" === section ? "" : "hidden"}>
            <Settings
              app={this.props.app}
              match={this.props.match}
              user={this.state.user}
              userId={this.props.match.params.userId}
              profileInterface={this.profileInterface}
            />
          </div>
        }

        <br/>
      </>
    )
  }
}
